import { useState, useEffect } from 'react';
import apiUser from '../../apiUser';
import { fmtBRL, fmtComp, nomeContrato } from './format';

// Pendências do cancelamento de contrato (spec 2026-10-27): ciclo já aprovado/faturado
// depois da data de cancelamento, ou ajuste retroativo sem ciclo que o receba.
// O ERP não mexe no Elleven: o financeiro resolve lá e marca aqui.
const dataBR = (d) => (d ? String(d).slice(0, 10).split('-').reverse().join('/') : '—');

const EstornosPendentes = ({ aviso, onMudou }) => {
    const [pendentes, setPendentes] = useState([]);
    const [notas, setNotas] = useState({});
    const [salvando, setSalvando] = useState(null);

    const carregar = async () => {
        try {
            const { data } = await apiUser.get('/faturamento/estornos', { params: { status: 'pendente' } });
            if (data.success) setPendentes(data.dados || []);
        } catch { /* silencioso: o painel segue sem o card */ }
    };
    useEffect(() => { carregar(); }, []);

    if (!pendentes.length) return null;

    const decidir = async (e, acao) => {
        setSalvando(e.id);
        try {
            const { data } = await apiUser.post(`/faturamento/estornos/${e.id}/${acao}`, { nota: notas[e.id] || '' });
            aviso(data.message, data.success ? 'success' : 'warning');
            if (data.success) { carregar(); onMudou && onMudou(); }
        } catch { aviso('Erro ao comunicar com o servidor.'); }
        setSalvando(null);
    };

    return (
        <div className='mb-5 rounded-lg border border-zinc-300 bg-zinc-50 dark:bg-zinc-800/60 dark:border-zinc-600 p-4'>
            <p className='text-sm font-semibold text-zinc-900 dark:text-zinc-100'>
                {pendentes.length} pendência(s) de contrato cancelado para resolver no Elleven
            </p>
            <p className='text-xs text-zinc-700 dark:text-zinc-300 mb-3'>
                Cobrança já aprovada ou faturada depois da data de cancelamento. Cancele o boleto, faça a nota de crédito ou devolva (se já foi pago) no Elleven e marque aqui o que foi feito.
            </p>
            <div className='flex flex-col gap-3'>
                {pendentes.map((e) => (
                    <div key={e.id} className='rounded-lg bg-white dark:bg-gray-800 border border-zinc-200 dark:border-gray-600 p-3 text-sm'>
                        <div className='flex flex-wrap items-baseline justify-between gap-2'>
                            <span className='font-semibold text-gray-900 dark:text-gray-100'>
                                {e.cliente_nome}{e.contrato_nome ? ` — ${nomeContrato(e)}` : ''}
                            </span>
                            <span className='text-gray-900 dark:text-gray-100'>
                                {e.tipo === 'estorno' ? 'Estornar' : 'Cobrar à parte'}: <b>{fmtBRL(e.valor)}</b>
                            </span>
                        </div>
                        <p className='text-gray-700 dark:text-gray-300 mt-1'>
                            {e.descricao}{e.competencia ? ` · ciclo de ${fmtComp(e.competencia)} (${e.status_ciclo})` : ''} · cancelado em {dataBR(e.data_cancelamento)}
                        </p>
                        <div className='flex flex-wrap items-end gap-2 mt-2'>
                            <div className='flex-1 min-w-[220px]'>
                                <label className='block text-xs text-gray-600 dark:text-gray-400 mb-1'>O que foi feito no Elleven (ou motivo do descarte)</label>
                                <input type='text' value={notas[e.id] || ''} onChange={(ev) => setNotas({ ...notas, [e.id]: ev.target.value })}
                                    className='border rounded-lg p-1.5 w-full dark:bg-gray-700 dark:text-white' />
                            </div>
                            <button disabled={salvando === e.id} onClick={() => decidir(e, 'resolver')}
                                className='px-3 py-1.5 rounded-lg text-white font-semibold whitespace-nowrap disabled:opacity-50' style={{ backgroundColor: '#9ac31c' }}>
                                Resolvido
                            </button>
                            <button disabled={salvando === e.id} onClick={() => decidir(e, 'descartar')}
                                className='px-3 py-1.5 rounded-lg bg-gray-200 hover:bg-gray-300 dark:bg-gray-600 dark:text-white whitespace-nowrap disabled:opacity-50'>
                                Descartar
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default EstornosPendentes;
